export enum UtapClaimStatus {
    REVIEWING = `REVIEWING`,
    REJECTED = `REJECTED`,
    APPROVED = `APPROVED`,
    NEW = `NEW`,
}